import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { Input } from "components/base/Form";
import { Alert } from "components/base/Toast";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CREATE_PROJECT } from "./graphql";

const CreateNewProjectView = () => {
  const [name, setName] = useState("");
  const navigate = useNavigate();
  const [createProject, createProjectRes] = useMutation(CREATE_PROJECT, {
    variables: { name },
    onCompleted: (data) => {
      navigate(`/development/projects/${data.createProject.project.id}`);
      Alert("success", "Project created successfully!");
    },
    onError(error) {
      Alert("error", parseError(error));
    },
    refetchQueries: ["FETCH_PROJECTS"],
  });

  return (
    <div className="text-sm">
      <table className=" whitespace-nowrap -mx-2">
        <tbody>
          <tr>
            <td>Name:</td>
            <td className="w-full">
              <Input
                className="w-full"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter project name"
              />
            </td>
          </tr>
        </tbody>
      </table>

      <Button
        className="mt-6"
        primary
        disabled={!name}
        onClick={createProject}
        loading={createProjectRes.loading}
      >
        Create
      </Button>
    </div>
  );
};

export default CreateNewProjectView;
